import { pick, forEach, invoker, flip, compose } from "ramda";

const placeToMarker = pick(["id", "name", "latitude", "longitude", "slug"]);
const addMarker = flip(invoker(1, "addMarker"));

function topo({ element, atlas, places, center }) {
  const map = atlas.create({ center }, element);
  const createMarker = addMarker(map);
  const createPlace = compose(createMarker, placeToMarker);
  const createPlaces = forEach(createPlace);

  places.observe(createPlaces);

  return map;
}

export default topo;



// WEBPACK FOOTER //
// ./app/javascript/packs/modules/topo/topo.js